import { canActivate, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { Routes } from '@angular/router';

export const WebEsoluzionRoutes: Routes = [
  {
    path: 'lawyer',
    loadChildren: () => import('./components/lawyer/lawyer.routes').then(r => r.LawyerRoutes),
    ...canActivate(() => redirectUnauthorizedTo(['login'])),
  },
  {
    path: 'law-office',
    loadChildren: () => import('./components/law-office/law-office.routes').then(r => r.LawOfficeRoutes),
    ...canActivate(() => redirectUnauthorizedTo(['login'])),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'law-office'
  }
];
